export default __webpack_public_path__ + "static/media/Subaru-logo-vertical-black.52a0a4d3.png";